import {
  ConstructorResultsSdkResponseObject,
  PopularSearchesData,
} from 'components/SA/SearchProvider/constructorTypes'
import { SearchOptionLinksObject } from 'components/SA/SearchProvider/types'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'

export const transformConstructorRecommendationsResults = (
  recommendationsResponse: ReadonlyArray<ConstructorResultsSdkResponseObject<PopularSearchesData>>
): ReadonlyArray<SearchOptionLinksObject> => {
  return (
    (recommendationsResponse || []).map(({ value }) => ({
      label: value?.toLowerCase(),
      link: addStoreLocaleByCookie(`/all?query=${encodeURIComponent(value)}`),
    })) || []
  )
}
